var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006084"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1005",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#F1F8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_515_4952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 18,
    y: 18,
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_515_4952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M46.5833 48.625L37.3958 39.4375C36.6667 40.0208 35.8281 40.4826 34.8802 40.8229C33.9323 41.1632 32.9236 41.3333 31.8542 41.3333C29.2049 41.3333 26.9627 40.4158 25.1276 38.5807C23.2925 36.7457 22.375 34.5035 22.375 31.8542C22.375 29.2049 23.2925 26.9627 25.1276 25.1276C26.9627 23.2925 29.2049 22.375 31.8542 22.375C34.5035 22.375 36.7457 23.2925 38.5807 25.1276C40.4158 26.9627 41.3333 29.2049 41.3333 31.8542C41.3333 32.9236 41.1632 33.9323 40.8229 34.8802C40.4826 35.8281 40.0208 36.6667 39.4375 37.3958L48.625 46.5833L46.5833 48.625ZM31.8542 38.4167C33.6771 38.4167 35.2266 37.7786 36.5026 36.5026C37.7786 35.2266 38.4167 33.6771 38.4167 31.8542C38.4167 30.0312 37.7786 28.4818 36.5026 27.2057C35.2266 25.9297 33.6771 25.2917 31.8542 25.2917C30.0312 25.2917 28.4818 25.9297 27.2057 27.2057C25.9297 28.4818 25.2917 30.0312 25.2917 31.8542C25.2917 33.6771 25.9297 35.2266 27.2057 36.5026C28.4818 37.7786 30.0312 38.4167 31.8542 38.4167Z",
    fill: "#27447C"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSearch);
export default __webpack_public_path__ + "static/media/blue-search.bdc3a861b6f357897e46669f5cbf3fcb.svg";
export { ForwardRef as ReactComponent };